/** @format */

// Func = limiting Scope for this file
(function () {
  function resizeWindow() {}
  function scrollDown() {
    const top = window.scrollY;
    const headerEl = document.getElementById("header");
    if (top > 40) {
      headerEl.classList.add("scroll");
    } else {
      headerEl.classList.remove("scroll");
    }
    let animatedEl = document.getElementsByClassName("animate-fade-2");
    const h = window.innerHeight;
    var i;
    for (i = 0; i < animatedEl.length; i++) {
      var viewportOffset = animatedEl[i].getBoundingClientRect();
      let topPos = viewportOffset.top;
      //animatedEl[i].innerHTML = topPos;
      if (topPos <= h * 0.8) {
        animatedEl[i].classList.add("fade-in");
      }
    }
  }

  $(document).ready(function () {
    //Call function with browser is resized.
    $(window).resize(function (event) {
      resizeWindow();
    });
    resizeWindow();

    $("#privary-navigation a").click(function (event) {
      if ($(this).siblings(".submenu").length > 0) {
        event.preventDefault();
        if ($(this).siblings(".submenu").is(":hidden")) {
          $("#privary-navigation .submenu").slideUp();
          $(this).siblings(".submenu").stop().slideDown();
        } else {
          $(this).siblings(".submenu").stop().slideUp();
        }
      }
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

    const menu_btn = document.querySelector(".js-menu-btn");
    if (menu_btn) {
      menu_btn.addEventListener("click", function () {
        document.querySelector("body").classList.toggle("nav-open");
      });
    }
  });

  $(window).on('load', function(){
    if ($(".rellax").length > 0) {
      var rellax = new Rellax(".rellax");
    }
  });

  scrollDown();

  document.addEventListener("scroll", function () {
    scrollDown();
  });

  // booking widget functionality
  const overlayBooking = document.getElementById("overlay-booking");
  if (overlayBooking) {
    document
      .getElementsByClassName("js-open-booking")[0]
      .addEventListener("click", function () {
        overlayBooking.classList.add("open");
        $("#CheckIn").datepicker().datepicker("setDate", "0");
        $("#CheckOut").datepicker().datepicker("setDate", "3");
      });
    document
      .getElementsByClassName("overlay-booking__close")[0]
      .addEventListener("click", function () {
        overlayBooking.classList.remove("open");
      });
  }

  const bookingSelect = document.getElementById("booking__select");
  const bookingForm = document.getElementById("booking-form");
  const checkInAlt = document.getElementById("CheckIn__alt");
  const checkOutAlt = document.getElementById("CheckOut__alt");
  const fieldsWrapper = document.getElementById("hidden_fields");

  let hyden = {
    bookingUrl: "https://be.synxis.com/?Hotel=77474&start=availresults",
    checkIn: "arrive",
    checkOut: "depart",
    dateFormat: "mm-dd-yy",
  };

  let hugo = {
    bookingUrl: "https://hotelhugony.reztrip.com/search?",
    checkIn: "arrival_date",
    checkOut: "departure_date",
    dateFormat: "yy-mm-dd",
  };

  let henri = {
    bookingUrl: "https://be.synxis.com/?Hotel=7157&start=availresults",
    checkIn: "arrive",
    checkOut: "depart",
    dateFormat: "mm-dd-yy",
  };

  let garden = {
    bookingUrl:
      "https://be.synxis.com/?Hotel=27213&Chain=10237&start=availresults",
    checkIn: "arrive",
    checkOut: "depart",
    dateFormat: "mm-dd-yy",
  };

  let hendricks = {
    bookingUrl: "https://be.synxis.com/?Hotel=6287&start=availresults",
    checkIn: "arrive",
    checkOut: "depart",
    dateFormat: "mm-dd-yy",
  };
  let grayson = {
    bookingUrl:
      "https://www.hyatt.com/shop/nycub?spiritCode=GraysonHotel&rate=Standard",
    checkIn: "checkinDate",
    checkOut: "checkoutDate",
    dateFormat: "yy-mm-dd",
  };
  function changeBooking(value) {
    $("#hidden_fields").empty();
    value = eval(value);
    let $be = value.bookingUrl.split("?");
    let $variables = $be[1].split("&");
    for (var i = 0; i < $variables.length; i++) {
      console.log($variables[i]);
      let varSplit = $variables[i].split("=");
      let variable_field = `<input type="hidden" name="${varSplit[0]}" value="${varSplit[1]}">`;
      $("#hidden_fields").append(variable_field);
    }
    bookingForm.action = $be[0];
    checkInAlt.name = value.checkIn;
    checkOutAlt.name = value.checkOut;
    $("#CheckIn").datepicker("option", "altFormat", value.dateFormat);
    $("#CheckOut").datepicker("option", "altFormat", value.dateFormat);
  }

  bookingSelect.addEventListener("change", function () {
    let thisValue = bookingSelect.value;
    changeBooking(thisValue);
  });

  $("#CheckIn").datepicker({
    changeMonth: true,
    dateFormat: "M dd",
    altField: "#CheckIn__alt",
    minDate: 0,
    onSelect: function (selectedDate) {
      var getDate = $(this).datepicker("getDate");
      var newDate = new Date(getDate.getTime());
      newDate.setDate(newDate.getDate() + 3);
      $("#CheckOut").datepicker("setDate", newDate);
      $("#CheckOut").datepicker("option", "minDate", selectedDate);
    },
  });
  $("#CheckOut").datepicker({
    changeMonth: true,
    dateFormat: "M dd",
    altField: "#CheckOut__alt",
    onSelect: function (selectedDate) {},
  });

  //*** end booking widget functionality
  const header_navigation = document.getElementById("header__navigation");
  if (header_navigation) {
    $("#start-content").on("click", function (e) {
      if (
        header_navigation.contains(e.target) ||
        document.getElementById("header__menu").contains(e.target)
      ) {
        // Clicked in box
      } else {
        document.querySelector("body").classList.remove("nav-open");
      }
    });
  }

  $(".landing-map__pin").click(function (event) {
    event.preventDefault();
    const thisHref = $(this).attr("href");
    if (!$(this).hasClass("active")) {
      $(".landing-map__item").fadeOut(500);
      setTimeout(function () {
        $(thisHref).fadeIn(500);
      }, 500);
      $(".landing-map__pin").removeClass("active");
      $(this).addClass("active");
    }
  });

  $(".js-go-top").click(function (event) {
    event.preventDefault();
    $("html,body").animate(
      {
        scrollTop: 0,
      },
      1200
    );
  });
})();
